/**
 * Node geometry. Pure, and imported by BOTH the simulation worker (for
 * collision radii) and the renderer, so the two can never disagree.
 */

/** World-unit radius at degree 0. */
export const BASE_R = 2.8;
export const GROWTH = 2.1;
/** Zoomed all the way out the graph should be legible dust, not nothing. */
export const MIN_R_PX = 1.5;
/** Purely a fill-rate guard. */
export const MAX_R_PX = 128;
/**
 * Node radii scale SUBLINEARLY with zoom. Linear scaling is geometrically
 * honest but reads wrong at both ends: fit-zoomed a big vault becomes dust
 * drowned by its own links, and fully zoomed in a node fills the screen.
 * Obsidian's dots stay plump at overview and modest up close; z^0.6 is that.
 */
export const RADIUS_ZOOM_EXP = 0.6;

export function radiusZoom(z: number): number {
  return Math.pow(z, RADIUS_ZOOM_EXP);
}

/**
 * Base plus a sqrt term, deliberately not linear and not pure sqrt.
 *
 * Linear in degree lets one degree-200 hub crush everything else into
 * invisibility. Pure sqrt correctly compresses the tail but makes degree 1 vs
 * degree 4 a full 2x difference, which reads as noise rather than the uniform
 * field Obsidian shows. With a base, degrees 1 to 3 stay near-uniform (4.9 to
 * 6.4) while a degree-30 hub is 2.9x a leaf and a degree-100 hub 4.8x, the
 * clearly-dominant anchors the reference screenshots show.
 */
export function nodeRadius(degree: number, sizeMul: number): number {
  return (BASE_R + GROWTH * Math.sqrt(Math.max(0, degree))) * sizeMul;
}

export function screenRadius(degree: number, sizeMul: number, z: number): number {
  return Math.min(MAX_R_PX, Math.max(MIN_R_PX, nodeRadius(degree, sizeMul) * radiusZoom(z)));
}
